import PropTypes from "prop-types";
import "./styles.css";

export default function ClockIcon({ sx }) {
	return (
		<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.5 49.5" style={sx}>
			<g id="Layer_1-2">
				<path
					className="clock-icon-component"
					d="M24.67,0h.15C28.51,0,31.38,0,33.69.17c2.34.17,4.26.53,6,1.32,3.69,1.67,6.65,4.63,
					8.32,8.32.79,1.74,1.15,3.66,1.32,6,.17,2.31.17,5.18.17,
					8.86v.15c0,3.69,0,6.56-.17,8.86-.17,2.34-.53,4.26-1.32,
					6-1.67,3.69-4.63,6.65-8.32,8.32-1.74.79-3.66,1.15-6,
					1.32-2.31.17-5.18.17-8.86.17h-.15c-3.69,0-6.56,0-8.86-.17-2.34-.17-4.26-.53-6-1.32-3.69-1.67-6.65-4.63-8.32-8.32-.79-1.74-1.15-3.66-1.32-6C0,
					31.38,0,28.51,0,24.83v-.15C0,20.99,0,18.12.17,15.81c.17-2.34.53-4.26,1.32-6C3.16,6.12,6.12,3.16,9.81,1.49c1.74-.79,
					3.66-1.15,6-1.32C18.12,0,20.99,0,24.67,0ZM16.08,3.87c-2.14.16-3.56.46-4.74,1-2.87,1.3-5.17,3.6-6.47,6.47-.53,
					1.18-.84,2.6-1,4.74-.16,2.16-.16,4.89-.16,8.67s0,6.51.16,8.67c.16,2.14.46,3.56,1,4.74,
					1.3,2.87,3.6,5.17,6.47,6.47,1.18.53,2.6.84,4.74,1,2.16.16,4.89.16,8.67.16s6.51,
					0,8.67-.16c2.14-.16,3.56-.46,4.74-1,2.87-1.3,5.17-3.6,6.47-6.47.53-1.18.84-2.6,
					1-4.74.16-2.16.16-4.89.16-8.67s0-6.51-.16-8.67c-.16-2.14-.46-3.56-1-4.74-1.3-2.87-3.6-5.17-6.47-6.47-1.18-.53-2.6-.84-4.74-1-2.16-.16-4.89-.16-8.67-.16s-6.51,
					0-8.67.16ZM23.51,8.41c1.03,0,1.86.83,1.86,1.86v13.78l11.93,6.89c.89.51,1.19,1.65.68,2.54s-1.65,
					1.19-2.54.68l-12.86-7.43c-.57-.33-.93-.94-.93-1.61v-14.85c0-1.03.83-1.86,1.86-1.86Z"
				/>
			</g>
		</svg>
	);
}
ClockIcon.propTypes = {
	sx: PropTypes.object,
};
